import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Operator } from "../models/operator";

@Component({
  selector: "operator",
  templateUrl: "./operator.template.html",
  styleUrls: ["./operator.style.scss"]
})
export class OperatorComponent {
  @Input() model: Operator;
  @Output() edit = new EventEmitter();

  get readonly() {
    return this.model.readonly;
  }

  get editable() {
    return !this.readonly && false;
  }

  onClick() {
    if(!this.readonly) {
      this.model.keyword = this.model.keyword === "AND" ? "OR" : "AND";
      this.edit.emit();
    }
  }
}
